module.exports = __webpack_public_path__ + "img/banner1_12.87ab8e2f.png";